import Konva from "konva";
import Helper from "../Helper";
import Webfont from "../WebFont";
import Translation from "../Translation";

export default class _TextPath extends Konva.TextPath{
    constructor(config, textJSON){
        super(config);
        this.className = 'TextPath';
        this.textureObj = undefined;
        this.fontLoaded = false;
        this._textJSON = textJSON;
    }

    _sceneFunc(ctx){
        if(this.getAttr('name') === 'content'){
            if(this.fontLoaded){
                //ctx.save();
                super._sceneFunc(ctx);
                var group_pos = this.getParent().position();
                var frame_pos = this.position();

                ctx.rotate((this.rotation() * -1 )* Math.PI / 180);

                
                if(this.textureObj){
                    ctx.globalCompositeOperation = 'source-in';

                    var sumarryRotation = (this.rotation() * -1 )* Math.PI / 180;
                    var x = (group_pos.x+frame_pos.x)*-1;
                    var y = (group_pos.y+frame_pos.y)*-1;

                    let rotate = this.getAttr('rotate_texture');
                    let summaryRotation = 0, z;
                    if(rotate)
                    {
                        if(rotate == 270)
                        {
                            summaryRotation = (rotate)* Math.PI / 180;
                            z = x;
                            x = y-1000 + ((group_pos.y+frame_pos.y)*2);
                            y = z;
                        }
                        if(rotate == 90)
                        {
                            summaryRotation = (rotate)* Math.PI / 180;
                            z = x-1000 + ((group_pos.x+frame_pos.x)*2);
                            x = y;
                            y = z;
                        }
                    }

                    ctx.rotate(summaryRotation);
                    ctx.drawImage(this.textureObj, 0, 0, 1000, 1000, x, y, 1000, 1000);  
                }

                ctx.restore();

                if(this.getAttr('innerShadowEnabled')){
                    var copy_canvas = document.createElement('canvas');
                    var copy_ctx = copy_canvas.getContext('2d');
                    copy_canvas.width = ctx._context.canvas.width;
                    copy_canvas.height = ctx._context.canvas.height;
                    
                    copy_ctx.drawImage(ctx._context.canvas, 0, 0);
                    
                    ctx.globalCompositeOperation = 'source-over';
                    ctx.shadowBlur = 0; 
                    ctx.shadowOffsetX = 0.5;
                    ctx.shadowOffsetY = 0.5;
                    ctx.shadowColor = 'black';
                    ctx.drawImage(copy_canvas,   0, 0, ctx._context.canvas.width, ctx._context.canvas.height, (group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000 );  
                    ctx.shadowBlur = 0; 
                    ctx.shadowOffsetX = -0.5;
                    ctx.shadowOffsetY = -0.5;
                    ctx.shadowColor = 'black';
                    ctx.drawImage(copy_canvas,   0, 0, ctx._context.canvas.width, ctx._context.canvas.height, (group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000 );  


                    ctx.fillStyle = 'black';
                    ctx.shadowColor="transparent"; 
                    ctx.globalCompositeOperation = "xor";
                    ctx.fillRect((group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000);
                    

                    ctx.shadowBlur = this.getAttr('innerShadowBlur');
                    ctx.shadowOffsetX = this.getAttr('innerShadowOffsetX'); 
                    ctx.shadowOffsetY = this.getAttr('innerShadowOffsetY');

                    
                    let rgb = Helper.hexToRgb(this.getAttr('innerShadowColor'));
                            ctx.shadowColor = 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + this.getAttr('innerShadowOpacity') + ')';

                    ctx.drawImage(ctx._context.canvas,  0, 0, ctx._context.canvas.width, ctx._context.canvas.height, (group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000 );  
            
                    ctx.globalCompositeOperation = "destination-atop";
                    ctx.shadowColor = "transparent";         // remove shadow !
                    ctx.drawImage(copy_canvas,   0, 0, ctx._context.canvas.width, ctx._context.canvas.height, (group_pos.x+frame_pos.x)*-1, (group_pos.y+frame_pos.y)*-1, 1000, 1000 );  
        
                }
                ctx.restore();
            }
        }
    }

    load(_resolve, _reject){
        new Promise((resolve, reject) => {
            this.loadFont(resolve, reject);
        }).then(resolveValue => {
            this.fontLoaded = true;
            let textTemp = this.getText();
            this.setText('');
            this.setText(textTemp);

            if(this.getAttr('texture_src'))
                new Promise((resolve, reject) => {
                    this.loadTexture(resolve, reject);
                }).then(resolveValue => {
                    this.textureObj = resolveValue;
                    _resolve("OK");
                }).catch(err => _reject(err))
            else
                _resolve("OK");
        });
    }

    loadTexture(resolve, reject){
        if(!this.textureObj && this.getAttr('texture_src')){
            let img = Helper.loadImage(
                this.getAttr('texture_src'),
                () => {
                    resolve(img);
                },
                (err) => {
                    reject(err);
                }
            );
        }else{
            resolve();
        }
    }

    loadFont(resolve, reject){
        Webfont.loadFont({
                familyName: this.getAttr('fontFamily'),
                fontSize: this.getAttr('fontSize')
            },
            resolve, reject);
    }

    _setTextJSON(text, lang){
        let warning = false;
        let frame = this.getLayer().findOne('.frame');

        this.setText(" ");
        var space_width = this.getTextWidth();

        if(text.length > this.maxChars()){
            warning = true;
            text = text.substr(0, this.maxChars());
        }

        this.attrs.textJSON[lang].text = text
        this.setText(text);
        let text_width = this.getTextWidth();
        
        let wid = parseInt(frame.width());
        let len = parseInt(frame.height());
        let PI = 3.141592654;
        let ellipse = ((Math.sqrt(.5 * ((len * len) + (wid * wid)))) * (PI * 2)) / 2;
        ellipse = ellipse / 2;
        
        if(ellipse > text_width){
            let free_space = (ellipse - text_width) / 2;
            let spaces = parseInt(free_space / space_width);
            
            if(spaces > 0)
            {
                let offset = parseInt(this.ellipseOffset()) || 0;
                
                spaces = spaces+offset; // korekta bo automat ma duży rozstzał
                
                let padding = Array(spaces).join(' ');
                this.setText(padding + text);
                this.attrs.textJSON[lang].text = padding + text;
            }
        }

        return warning;
    }

    _getTextJSONText(lang){
        this.setTextJSONIfNotExist(lang);
        // this.fitText(lang);
        return this.textJSON()[lang].text.trim();
    }

    _getTextJSONLabel(lang){
        this.setTextJSONIfNotExist(lang);
        return this.textJSON()[lang].label && this.textJSON()[lang].label && this.textJSON()[lang].label.trim() != "" ? this.textJSON()[lang].label.trim() : Translation.getTranslation('defaultInputLabel');
    }

    _getTextJSONSentence(lang){
        this.setTextJSONIfNotExist(lang);
        return this.textJSON()[lang].attributes.sentence;
    }

    setTextJSONIfNotExist(lang){
        let textjson = this.textJSON();
        if(Object.keys(this.textJSON()).length === 0){
            textjson = this._textJSON.getObjectCopy();
            textjson.pl.text = this.getText();
            textjson.pl.attributes.sentence = this.sentence();
            textjson.pl.attributes.author = this.sentence_author();
            this.textJSON(textjson);
        }

        if(typeof textjson[lang] === "undefined"){
            textjson[lang] = this._textJSON.getLangOptionsObjectCopy();
            this.textJSON(textjson);
        }
    }
}

Konva._TextPath = _TextPath;